import React from 'react';

import Header from './Header'
// import Sidebar from './Sidebar'
import Footer from './Footer'
import FullPageLoader from '../Common/FullPageLoader';

const Base = props => (
    <div>
        <Header />

        {/* <Sidebar /> */}
        
        <section className="section-container">
            {props.children}
        </section>

        <Footer />
        <FullPageLoader />
    </div>
)

export default Base;
